import { CHAMPIONS } from "../data/champions";
import { levelForXp } from "../units/UnitStats";
import type { RosterEntry, StarLevel } from "./RunState";
import type { Difficulty } from "../data/difficulty";

const LS_HISTORY = "lolRogue_runHistory";
const MAX_RECORDS = 20;

export interface WinRecord {
  date: string; // ISO
  /** New: explicit difficulty. */
  difficulty?: Difficulty;
  /** Legacy field — pre-difficulty-rework runs only had impossibleMode (now treated as "hard"). */
  impossibleMode?: boolean;
  champions: {
    championId: string;
    displayName: string;
    level: number;
    stars: StarLevel;
  }[];
}

export function recordWin(roster: RosterEntry[], difficulty: Difficulty = "normal"): void {
  const history = loadRunHistory();
  history.unshift({
    date: new Date().toISOString(),
    difficulty,
    champions: roster.map((e) => ({
      championId: e.championId,
      displayName: CHAMPIONS[e.championId]?.displayName ?? e.championId,
      level: levelForXp(e.xp),
      stars: e.stars ?? 1,
    })),
  });
  if (history.length > MAX_RECORDS) history.length = MAX_RECORDS;
  try { localStorage.setItem(LS_HISTORY, JSON.stringify(history)); } catch {}
}

/** Resolve a record's difficulty, accounting for legacy `impossibleMode: true` records. */
export function recordDifficulty(record: WinRecord): Difficulty {
  if (record.difficulty) return record.difficulty;
  return record.impossibleMode ? "hard" : "normal";
}

export function loadRunHistory(): WinRecord[] {
  try {
    const raw = localStorage.getItem(LS_HISTORY);
    return raw ? (JSON.parse(raw) as WinRecord[]) : [];
  } catch { return []; }
}
